import { Contact } from '@mm/state/interfaces/contacts';
import React from 'react';
import { ReactComponent as MailUndeliverableIcon } from './mail_undeliverable.svg';
import { ReactComponent as MailUnknownIcon } from './mail_unknown.svg';
import { ReactComponent as MailVerifiedIcon } from './mail_verified.svg';

export const EmailVerificationStatusIcon = (props: {
  contact: Contact;
  className: string;
}) => {
  const { className } = props;
  const { email, deliverable } = props.contact;
  if (!email) {
    return null;
  }
  if (deliverable === true) {
    return (
      <div className={className} title="Email Verified">
        <MailVerifiedIcon />
      </div>
    );
  }
  if (deliverable === false) {
    return (
      <div className={className} title="Email Verification Failed">
        <MailUndeliverableIcon />
      </div>
    );
  }
  return (
    <div className={className} title="Email Unverified">
      <MailUnknownIcon />
    </div>
  );
};
